import areas from '../../data/areas'
import { Area } from '../../models/AreaHierarchy'



// initial state
const state = () => ({

})

// getters
const getters = {
    stats: () => {
        const areas = Area.all()
        const stats = {}
        stats.total = areas.length
        stats.completed = areas.filter((area) => area.completed).length
        stats.progress = Math.round(stats.completed / stats.total * 100)
        return stats
    },
    filtered: (state, getters, rootState) => {
        switch(rootState.configurations.filter) {
          case "completed":
            return Area.query().where('completed', true).get()
          case "uncompleted":
            return Area.query().where('completed', false).get()
          default:
            return Area.query().all();
        }
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', areas)
    },
    complete({ commit }, area) {
        commit('complete', { area })
    },
    uncomplete({ commit }, area) {
        commit('uncomplete', { area })
    }
}

// mutations
const mutations = {
    load(state, areas) {
        // Restore completed areas
        areas.forEach(area => {
            if (Area.query().where((persistedArea) => { return persistedArea.completed && persistedArea.id == area.id }).exists()) {
                area.completed = true
            }
        });
        Area.create({
            data: areas
        })
    },
    complete(state, { area }) {
        Area.update({
            where: area.id,
            data: {
                completed: true
            }
        })
    },
    uncomplete(state, { area }) {
        Area.update({
            where: area.id,
            data: {
                completed: false
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
